
export interface ICountryCodeAlpha2 {
    dialingCode: string
    alphaCode: string
}

export  const countryCodeAlpha2: ICountryCodeAlpha2[] = [
    { dialingCode: "+91", alphaCode: "IN" },
    { dialingCode: "+376", alphaCode: "AD" },
    { dialingCode: "+971", alphaCode: "AE" },
    { dialingCode: "+93", alphaCode: "AF" },
    { dialingCode: "+1268", alphaCode: "AG" },
    { dialingCode: "+1264", alphaCode: "AI" },
    { dialingCode: "+355", alphaCode: "AL" },
    { dialingCode: "+374", alphaCode: "AM" },
    { dialingCode: "+244", alphaCode: "AO" },
    { dialingCode: "+54", alphaCode: "AR" },
    { dialingCode: "+1684", alphaCode: "AS" },
    { dialingCode: "+43", alphaCode: "AT" },
    { dialingCode: "+61", alphaCode: "AU" },
    { dialingCode: "+297", alphaCode: "AW" },
    { dialingCode: "+994", alphaCode: "AZ" },
    { dialingCode: "+387", alphaCode: "BA" },
    { dialingCode: "+1246", alphaCode: "BB" },
    { dialingCode: "+880", alphaCode: "BD" },
    { dialingCode: "+32", alphaCode: "BE" },
    { dialingCode: "+226", alphaCode: "BF" },
    { dialingCode: "+359", alphaCode: "BG" },
    { dialingCode: "+973", alphaCode: "BH" },
    { dialingCode: "+257", alphaCode: "BI" },
    { dialingCode: "+229", alphaCode: "BJ" },
    { dialingCode: "+1441", alphaCode: "BM" },
    { dialingCode: "+673", alphaCode: "BN" },
    { dialingCode: "+591", alphaCode: "BO" },
    { dialingCode: "+55", alphaCode: "BR" },
    { dialingCode: "+1242", alphaCode: "BS" },
    { dialingCode: "+975", alphaCode: "BT" },
    { dialingCode: "+267", alphaCode: "BW" },
    { dialingCode: "+375", alphaCode: "BY" },
    { dialingCode: "+501", alphaCode: "BZ" },
    { dialingCode: "+1", alphaCode: "CA" },
    { dialingCode: "+61", alphaCode: "CC" },
    { dialingCode: "+243", alphaCode: "CD" },
    { dialingCode: "+236", alphaCode: "CF" },
    { dialingCode: "+242", alphaCode: "CG" },
    { dialingCode: "+41", alphaCode: "CH" },
    { dialingCode: "+225", alphaCode: "CI" },
    { dialingCode: "+682", alphaCode: "CK" },
    { dialingCode: "+56", alphaCode: "CL" },
    { dialingCode: "+237", alphaCode: "CM" },
    { dialingCode: "+86", alphaCode: "CN" },
    { dialingCode: "+57", alphaCode: "CO" },
    { dialingCode: "+506", alphaCode: "CR" },
    { dialingCode: "+53", alphaCode: "CU" },
    { dialingCode: "+238", alphaCode: "CV" },
    { dialingCode: "+61", alphaCode: "CX" },
    { dialingCode: "+357", alphaCode: "CY" },
    { dialingCode: "+420", alphaCode: "CZ" },
    { dialingCode: "+49", alphaCode: "DE" },
    { dialingCode: "+253", alphaCode: "DJ" },
    { dialingCode: "+45", alphaCode: "DK" },
    { dialingCode: "+1767", alphaCode: "DM" },
    { dialingCode: "+1849", alphaCode: "DO" },
    { dialingCode: "+213", alphaCode: "DZ" },
    { dialingCode: "+593", alphaCode: "EC" },
    { dialingCode: "+372", alphaCode: "EE" },
    { dialingCode: "+20", alphaCode: "EG" },
    { dialingCode: "+291", alphaCode: "ER" },
    { dialingCode: "+34", alphaCode: "ES" },
    { dialingCode: "+251", alphaCode: "ET" },
    { dialingCode: "+358", alphaCode: "FI" },
    { dialingCode: "+679", alphaCode: "FJ" },
    { dialingCode: "+500", alphaCode: "FK" },
    { dialingCode: "+691", alphaCode: "FM" },
    { dialingCode: "+298", alphaCode: "FO" },
    { dialingCode: "+33", alphaCode: "FR" },
    { dialingCode: "+241", alphaCode: "GA" },
    { dialingCode: "+44", alphaCode: "GB" },
    { dialingCode: "+1473", alphaCode: "GD" },
    { dialingCode: "+995", alphaCode: "GE" },
    { dialingCode: "+594", alphaCode: "GF" },
    { dialingCode: "+233", alphaCode: "GH" },
    { dialingCode: "+350", alphaCode: "GI" },
    { dialingCode: "+299", alphaCode: "GL" },
    { dialingCode: "+220", alphaCode: "GM" },
    { dialingCode: "+224", alphaCode: "GN" },
    { dialingCode: "+590", alphaCode: "GP" },
    { dialingCode: "+240", alphaCode: "GQ" },
    { dialingCode: "+30", alphaCode: "GR" },
    { dialingCode: "+500", alphaCode: "GS" },
    { dialingCode: "+502", alphaCode: "GT" },
    { dialingCode: "+1671", alphaCode: "GU" },
    { dialingCode: "+245", alphaCode: "GW" },
    { dialingCode: "+595", alphaCode: "GY" },
    { dialingCode: "+852", alphaCode: "HK" },
    { dialingCode: "+504", alphaCode: "HN" },
    { dialingCode: "+385", alphaCode: "HR" },
    { dialingCode: "+509", alphaCode: "HT" },
    { dialingCode: "+36", alphaCode: "HU" },
    { dialingCode: "+62", alphaCode: "ID" },
    { dialingCode: "+353", alphaCode: "IE" },
    { dialingCode: "+972", alphaCode: "IL" },
    { dialingCode: "+246", alphaCode: "IO" },
    { dialingCode: "+964", alphaCode: "IQ" },
    { dialingCode: "+98", alphaCode: "IR" },
    { dialingCode: "+354", alphaCode: "IS" },
    { dialingCode: "+39", alphaCode: "IT" },
    { dialingCode: "+1876", alphaCode: "JM" },
    { dialingCode: "+962", alphaCode: "JO" },
    { dialingCode: "+81", alphaCode: "JP" },
    { dialingCode: "+254", alphaCode: "KE" },
    { dialingCode: "+996", alphaCode: "KG" },
    { dialingCode: "+855", alphaCode: "KH" },
    { dialingCode: "+686", alphaCode: "KI" },
    { dialingCode: "+269", alphaCode: "KM" },
    { dialingCode: "+1869", alphaCode: "KN" },
    { dialingCode: "+850", alphaCode: "KP" },
    { dialingCode: "+82", alphaCode: "KR" },
    { dialingCode: "+965", alphaCode: "KW" },
    { dialingCode: "+ 345", alphaCode: "KY" },
    { dialingCode: "+77", alphaCode: "KZ" },
    { dialingCode: "+856", alphaCode: "LA" },
    { dialingCode: "+961", alphaCode: "LB" },
    { dialingCode: "+1758", alphaCode: "LC" },
    { dialingCode: "+423", alphaCode: "LI" },
    { dialingCode: "+94", alphaCode: "LK" },
    { dialingCode: "+231", alphaCode: "LR" },
    { dialingCode: "+266", alphaCode: "LS" },
    { dialingCode: "+370", alphaCode: "LT" },
    { dialingCode: "+352", alphaCode: "LU" },
    { dialingCode: "+371", alphaCode: "LV" },
    { dialingCode: "+218", alphaCode: "LY" },
    { dialingCode: "+212", alphaCode: "MA" },
    { dialingCode: "+377", alphaCode: "MC" },
    { dialingCode: "+373", alphaCode: "MD" },
    { dialingCode: "+261", alphaCode: "MG" },
    { dialingCode: "+692", alphaCode: "MH" },
    { dialingCode: "+389", alphaCode: "MK" },
    { dialingCode: "+223", alphaCode: "ML" },
    { dialingCode: "+95", alphaCode: "MM" },
    { dialingCode: "+976", alphaCode: "MN" },
    { dialingCode: "+853", alphaCode: "MO" },
    { dialingCode: "+1670", alphaCode: "MP" },
    { dialingCode: "+596", alphaCode: "MQ" },
    { dialingCode: "+222", alphaCode: "MR" },
    { dialingCode: "+1664", alphaCode: "MS" },
    { dialingCode: "+356", alphaCode: "MT" },
    { dialingCode: "+230", alphaCode: "MU" },
    { dialingCode: "+960", alphaCode: "MV" },
    { dialingCode: "+265", alphaCode: "MW" },
    { dialingCode: "+52", alphaCode: "MX" },
    { dialingCode: "+60", alphaCode: "MY" },
    { dialingCode: "+258", alphaCode: "MZ" },
    { dialingCode: "+264", alphaCode: "NA" },
    { dialingCode: "+687", alphaCode: "NC" },
    { dialingCode: "+227", alphaCode: "NE" },
    { dialingCode: "+672", alphaCode: "NF" },
    { dialingCode: "+234", alphaCode: "NG" },
    { dialingCode: "+505", alphaCode: "NI" },
    { dialingCode: "+31", alphaCode: "NL" },
    { dialingCode: "+47", alphaCode: "NO" },
    { dialingCode: "+977", alphaCode: "NP" },
    { dialingCode: "+674", alphaCode: "NR" },
    { dialingCode: "+683", alphaCode: "NU" },
    { dialingCode: "+64", alphaCode: "NZ" },
    { dialingCode: "+968", alphaCode: "OM" },
    { dialingCode: "+507", alphaCode: "PA" },
    { dialingCode: "+51", alphaCode: "PE" },
    { dialingCode: "+689", alphaCode: "PF" },
    { dialingCode: "+675", alphaCode: "PG" },
    { dialingCode: "+63", alphaCode: "PH" },
    { dialingCode: "+92", alphaCode: "PK" },
    { dialingCode: "+48", alphaCode: "PL" },
    { dialingCode: "+508", alphaCode: "PM" },
    { dialingCode: "+872", alphaCode: "PN" },
    { dialingCode: "+1939", alphaCode: "PR" },
    { dialingCode: "+351", alphaCode: "PT" },
    { dialingCode: "+680", alphaCode: "PW" },
    { dialingCode: "+595", alphaCode: "PY" },
    { dialingCode: "+974", alphaCode: "QA" },
    { dialingCode: "+262", alphaCode: "RE" },
    { dialingCode: "+40", alphaCode: "RO" },
    { dialingCode: "+7", alphaCode: "RU" },
    { dialingCode: "+250", alphaCode: "RW" },
    { dialingCode: "+966", alphaCode: "SA" },
    { dialingCode: "+677", alphaCode: "SB" },
    { dialingCode: "+248", alphaCode: "SC" },
    { dialingCode: "+249", alphaCode: "SD" },
    { dialingCode: "+46", alphaCode: "SE" },
    { dialingCode: "+65", alphaCode: "SG" },
    { dialingCode: "+290", alphaCode: "SH" },
    { dialingCode: "+386", alphaCode: "SI" },
    { dialingCode: "+421", alphaCode: "SK" },
    { dialingCode: "+232", alphaCode: "SL" },
    { dialingCode: "+378", alphaCode: "SM" },
    { dialingCode: "+221", alphaCode: "SN" },
    { dialingCode: "+252", alphaCode: "SO" },
    { dialingCode: "+597", alphaCode: "SR" },
    { dialingCode: "+239", alphaCode: "ST" },
    { dialingCode: "+503", alphaCode: "SV" },
    { dialingCode: "+963", alphaCode: "SY" },
    { dialingCode: "+268", alphaCode: "SZ" },
    { dialingCode: "+1649", alphaCode: "TC" },
    { dialingCode: "+235", alphaCode: "TD" },
    { dialingCode: "+228", alphaCode: "TG" },
    { dialingCode: "+66", alphaCode: "TH" },
    { dialingCode: "+992", alphaCode: "TJ" },
    { dialingCode: "+690", alphaCode: "TK" },
    { dialingCode: "+670", alphaCode: "TL" },
    { dialingCode: "+993", alphaCode: "TM" },
    { dialingCode: "+216", alphaCode: "TN" },
    { dialingCode: "+676", alphaCode: "TO" },
    { dialingCode: "+90", alphaCode: "TR" },
    { dialingCode: "+1868", alphaCode: "TT" },
    { dialingCode: "+688", alphaCode: "TV" },
    { dialingCode: "+886", alphaCode: "TW" },
    { dialingCode: "+255", alphaCode: "TZ" },
    { dialingCode: "+380", alphaCode: "UA" },
    { dialingCode: "+256", alphaCode: "UG" },
    { dialingCode: "+1", alphaCode: "US" },
    { dialingCode: "+598", alphaCode: "UY" },
    { dialingCode: "+998", alphaCode: "UZ" },
    { dialingCode: "+1784", alphaCode: "VC" },
    { dialingCode: "+58", alphaCode: "VE" },
    { dialingCode: "+1284", alphaCode: "VG" },
    { dialingCode: "+1340", alphaCode: "VI" },
    { dialingCode: "+84", alphaCode: "VN" },
    { dialingCode: "+678", alphaCode: "VU" },
    { dialingCode: "+681", alphaCode: "WF" },
    { dialingCode: "+685", alphaCode: "WS" },
    { dialingCode: "+967", alphaCode: "YE" },
    { dialingCode: "+262", alphaCode: "YT" },
    { dialingCode: "+27", alphaCode: "ZA" },
    { dialingCode: "+260", alphaCode: "ZM" },
    { dialingCode: "+263", alphaCode: "ZW" },
    { dialingCode: "+971-3", alphaCode: "+971-3" },
    { dialingCode: "+971-6", alphaCode: "+971-6" },
    { dialingCode: "+971", alphaCode: "+971" },
]

export const getCodeFromAlpha = (alpha: string) => {
    let code = countryCodeAlpha2.find((item: ICountryCodeAlpha2) => item.alphaCode == alpha);
    return code ? code.dialingCode : ""
}

export const getAlphaFromCode = (code: string) => {
    let dialingCode = countryCodeAlpha2.find((item: ICountryCodeAlpha2) => item.dialingCode == code);
    return dialingCode ? dialingCode.alphaCode : ""

}
